import axios from 'axios'

async function get_tests(email,setTestArray,add_tests,dispatch,token){

try{

  const data = {
    email:email
  }

  const getTest = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-tests/`,data,{
           headers:{
                  "Content-Type":"application/json",
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{console.log(err)})

  if (getTest?.status == 200 && getTest?.data.success == true) {

  setTestArray(getTest?.data.tests)
  dispatch(add_tests(getTest?.data.tests))
  
}
}catch(err){
  console.log(err)
}
}

export default get_tests